export const restUrl = {
    user: {
        login: '/store/{storeId}/tmobile/identity/login',
        logout: '/store/{storeId}/tmobile/identity/logout',

        getNotifications: '/store/{storeId}/tmobile/user/{userId}/notifications',
        updateNotifications: '/store/{storeId}/tmobile/user/{userId}/notifications',
        getProfile: '/store/{storeId}/tmobile/user/{userId}/profile',
        updateProfile: '/store/{storeId}/tmobile/user/{userId}/profile',
        validateDealer: '/store/{storeId}/tmobile/user/{userId}/validate_dealer',
        retalStoreDetail: '/store/{storeId}/tmobile/user/{userId}/retail/{retailStoreId}',
        sendSurvery:  '/store/{storeId}/tmobile/user/{userId}/customer_feedback',
        getSurvey: '/store/{storeId}/tmobile/user/{userId}/survey'

    },
    search: {
        lookupCustomer: '/store/{storeId}/tmobile/customer/lookup',
        lookupOrder: '/store/{storeId}/tmobile/order/advanced_search'
    },
    catalog: {
        getRateplanList: '/store/{storeId}/tmobile/catalog/rateplan_list',
        getDeviceList: '/store/{storeId}/tmobile/catalog/device_list',
        getFeatureList: '/store/{storeId}/tmobile/catalog/feature_list',
        getAccessoryList: '/store/{storeId}/tmobile/catalog/accessory_list',

        getRateplanFilterList: '/store/{storeId}/tmobile/catalog/rateplan/filter_list',
        getDeviceFilterList: '/store/{storeId}/tmobile/catalog/device/filter_list',
        getFeatureFilterList: '/store/{storeId}/tmobile/catalog/feature/filter_list',
        getAccessoryFilterList: '/store/{storeId}/tmobile/catalog/accessory/filter_list',

        getRateplansByZipCode: '/store/{storeId}/tmobile/catalog/rateplan_list/byZipCode/{zipCode}',
        getDevicesByRateplan: '/store/{storeId}/tmobile/catalog/device_list/byRateplan/{rateplanSOC}',
        getDevicesByZipCode: '/store/{storeId}/tmobile/catalog/device_list/byZipCode/{zipCode}',
        getDevicesByManufacturer: '/store/{storeId}/tmobile/catalog/device_list/byManufacturer/{manufacturer}',
        getFeaturesByRateplanDevice: '/store/{storeId}/tmobile/catalog/feature_list/byRateplanDevice/{rateplanSOC}/{deviceSKU}',
        getAccessoriesByDevice: '/store/{storeId}/tmobile/catalog/accessory_list/byDevice/{deviceSKU}',

        getInventoryStatus: '/store/{storeId}/tmobile/catalog/product/inventory_status',
        getMoreInfoByProduct: '/store/{storeId}/tmobile/catalog/product/moreInfo/byProduct/{productId}',
        getMoreInfoByMfPartNumber: '/store/{storeId}/tmobile/catalog/product/moreInfo/byMfPartNumber/{mfPartNumber}',

        getEspotStatic: '/store/{storeId}/tmobile/espot/{espotName}/static',
        getEspotConfig: '/store/{storeId}/tmobile/espot/{espotName}/config',
        sendQuote: '/store/{storeId}/tmobile/document/quote/send_email',
        sendFeedback: '/store/{storeId}/tmobile/document/feedback/send_email'
      
    },
    customer: {
        getCreditLine: '/store/{storeId}/tmobile/customer/{accountNumber}/credit_line',
        getOrderList: '/store/{storeId}/tmobile/customer/{accountNumber}/order_list',
        getPreferredPrice: '/store/{storeId}/tmobile/customer/{accountNumber}/preferred_pricing/byCreditClass/{creditClass}',
        getSubscriberList: '/store/{storeId}/tmobile/customer/{accountNumber}/subscriber_list',
        getCustomer: '/store/{storeId}/tmobile/customer/byOrder/{orderId}',
        crediteligibilitycheck:'/store/{storeId}/tmobile/customer/crediteligibilitycheck',
        createCustomer: '/store/{storeId}/tmobile/customer/create',
        consumerCreditReport: '/store/{storeId}/tmobile/customer/consumer_credit',
        creditCheck: '/store/{storeId}/tmobile/customer/credit_check',
        switchCreditType: '/store/{storeId}/tmobile/customer/credit_type',
        getRateplanConflict: '/store/{storeId}/tmobile/customer/{accountNumber}/rateplan_conflict/{rateplanSOC}',
        validateAddress: '/store/{storeId}/tmobile/customer/validate_address',
        rateplanConflicts: '/store/{storeId}/tmobile/customer/soc_conflict/byRateplan/{rateplanSOC}',
        getToggleKey: '/store/{storeId}/tmobile/customer/toggle_data/{toggleKey}',
        validatePINFormat: '/store/{storeId}/tmobile/customer/pin_format/{pinCode}',
        profileByBAN: '/store/{storeId}/tmobile/customer/profileByBAN/{accountNumber}',
        profileByMSISDN: '/store/{storeId}/tmobile/customer/profileByMSISDN/{phoneNumber}',
        profileByToken: '/store/{storeId}/tmobile/customer/profileByToken/{toggleKey}',
        otpGenerate: '/store/{storeId}/tmobile/customer/{accountNumber}/otp_generate',
        otpValidate: '/store/{storeId}/tmobile/customer/{accountNumber}/otp_validate',
        paymentArrangement: '/store/{storeId}/tmobile/customer/{accountNumber}/payment_arrangement',
        generateMemo: '/store/{storeId}/tmobile/customer/memo',
        searchMemo: '/store/{storeId}/tmobile/customer/memo', // query params : refType and orderId
        createTentativeBan: '/store/{storeId}/tmobile/customer/tentative_ban',
        getCreditDetails: '/store/{storeId}/tmobile/customer/credit_details'
    },
    promotion: {
        promotionsByZipCode: '/store/{storeId}/tmobile/promotion/byZipCode/{zipCode}', // US335007 As a DASH dev I want UI changes for promotional information displayed when a configured Zip code is entered in Customer Information so that I can offer it to my customer
        promotionsByProduct: '/store/{storeId}/tmobile/promotion/byCatentry/{catentryId}'
    },
    order: {
        getNotes: '/store/{storeId}/tmobile/order/{orderId}/notes',
        createNotes: '/store/{storeId}/tmobile/order/{orderId}/notes',
        getReturnItems: '/store/{storeId}/tmobile/order/{orderId}/returnable_items',
        resendSAEmail: '/store/{storeId}/tmobile/order/{orderId}/resendSAEmail',
        resendDiscloserEmail: '/store/{storeId}/tmobile/order/{orderId}/resendDiscloserEmail',
        refreshCreditClass: '/store/{storeId}/tmobile/order/{orderId}/refresh_credit_class',
        createNewOrder:'/store/{storeId}/tmobile/order/{orderId}/order_copy',
        paperlessBilling: '/store/{storeId}/tmobile/order/{orderId}/paperless_billing/{zipCode}',
        doubleEIPEcl: '/store/{storeId}/tmobile/order/{orderId}/doubleEIPEcl',
        cancelOrder: '/store/{storeId}/tmobile/order/{orderId}/cancel',
        releaseOrder: '/store/{storeId}/tmobile/order/{orderId}/release'
    },
    cart: {
        getCart: '/store/{storeId}/tmobile/cart/{orderId}',
        getCartSummary: '/store/{storeId}/tmobile/cart/{orderId}/summary',
        getCancelSummary: '/store/{storeId}/tmobile/cart/{orderId}/summary',
        getCartFinance: '/store/{storeId}/tmobile/cart/{orderId}/finance',
        getCartShipping: '/store/{storeId}/tmobile/cart/{orderId}/shipping',
        getCartPayment: '/store/{storeId}/tmobile/cart/{orderId}/payment',
        getCartPromotions: '/store/{storeId}/tmobile/cart/{orderId}/promotion_code',
        getAssociatedOrders: '/store/{storeId}/tmobile/cart/{orderId}/associated_orders',

        createCart: '/store/{storeId}/tmobile/cart/create',
        updateCart: '/store/{storeId}/tmobile/cart/{orderId}',
        createPackage: '/store/{storeId}/tmobile/cart/{orderId}/package/create',
        deletePackage: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}',
        copyPackage: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/copy',
        createRateplan: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/rateplan',
        updateRateplan: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/rateplan/{orderItemId}',
        deleteRateplan: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/rateplan/{orderItemId}',
        createDevice: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/device',
        updateDevice: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/device/{orderItemId}',
        deleteDevice: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/device/{orderItemId}',
        createFeature: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/feature',
        updateFeature: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/feature/{orderItemId}',
        deleteFeature: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/feature/{orderItemId}',
        createAccessory: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/accessory',
        updateAccessory: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/accessory/{orderItemId}',
        deleteAccessory: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/accessory/{orderItemId}',
        applyPromo: '/store/{storeId}/tmobile/cart/{orderId}/promotion_code',
        deletePromo: '/store/{storeId}/tmobile/cart/{orderId}/promotion_code/{promoCode}',
        payExtra: '/store/{storeId}/tmobile/cart/{orderId}/extra_payment',
        adjustPrice: '/store/{storeId}/tmobile/cart/{orderId}/adjust_price',
        resloveConflicts: '/store/{storeId}/tmobile/cart/{orderId}/resolve_conflicts',
        featureConflicts: '/store/{storeId}/tmobile/cart/{orderId}/soc_conflict',
        validateCart: '/store/{storeId}/tmobile/cart/{orderId}/validate',
        calculate: '/store/{storeId}/tmobile/cart/{orderId}/calculate',
        returnItems: '/store/{storeId}/tmobile/cart/{orderId}/return_items',
        exchangeItems: '/store/{storeId}/tmobile/cart/{orderId}/exchange_items',
        saveDigitsMapping: '/store/{storeId}/tmobile/cart/{orderId}/digits_mapping',
        returnExchangeItems: '/store/{storeId}/tmobile/cart/{orderId}/return_exchange_items',
        issueCredit: '/store/{storeId}/tmobile/cart/{orderId}/issue_credit',
        issueCreditItems: '/store/{storeId}/tmobile/cart/{orderId}/issue_credit_items',
        convertFullPrice: '/store/{storeId}/tmobile/cart/{orderId}/convert_fullprice',
        lookupNpa: '/store/{storeId}/tmobile/cart/{orderId}/npaByZipCode/{zipCode}',
        clearProducts: '/store/{storeId}/tmobile/cart/{orderId}/clear_products',
        trackingInfo: '/store/{storeId}/tmobile/cart/{orderId}/trackinginfo',
        shippingLabel: '/store/{storeId}/tmobile/cart/{orderId}/shippinglabel',
        dmSync: '/store/{storeId}/tmobile/cart/{orderId}/dm_sync',
        calculateTax: '/store/{storeId}/tmobile/cart/{orderId}/calculate_tax',
    },
    checkout: {
        getShippingMode: '/store/{storeId}/tmobile/cart/{orderId}/shipping_method',
        updateShippingMode: '/store/{storeId}/tmobile/cart/{orderId}/shipping_method',
        shippingAddressUpdate: '/store/{storeId}/tmobile/cart/{orderId}/shipping_address',
        shippingAddressDelete: '/store/{storeId}/tmobile/cart/{orderId}/shipping_address',
        ppuAddressDelete: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/ppu_address',
        e911AddressDelete: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/e911_address',
        ccAddressDelete: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/cc_address',
        portingNumberDelete: '/store/{storeId}/tmobile/cart/{orderId}/package/{packageId}/{lineId}/portin_eligibility',
        updateCustomerInfo: '/store/{storeId}/tmobile/cart/{orderId}/customer',
        sendFinanceDiscloser: '/store/{storeId}/tmobile/order/{orderId}/finance_discloser',
        getServiceAgreement: '/store/{storeId}/tmobile/cart/{orderId}/service_agreement',
        realTimeInventory: '/store/{storeId}/tmobile/cart/{orderId}/check_inventory',
        submitOrder: '/store/{storeId}/tmobile/cart/{orderId}/submit',
        getCardType: '/store/{storeId}/tmobile/checkout/{orderId}/card_type/{cardNumber}',
        getPublicKey: '/store/{storeId}/tmobile/checkout/{orderId}/payments/publicKey',
        validateSim: '/store/{storeId}/tmobile/checkout/{orderId}/sim_validate/{simNumber}',
        lookupNpaNxx: '/store/{storeId}/tmobile/checkout/{orderId}/npa_nxx/{zipCode}',
        submitByos: '/store/{storeId}/tmobile/checkout/{orderId}/submit',
        saporderlist: '/store/{storeId}/tmobile/cart/{orderId}/saporderlist',
        sapitemdetails: '/store/{storeId}/tmobile/cart/{orderId}/orderlinedetails',
        purchaseEstimate: '/store/{storeId}/tmobile/checkout/{orderId}/purchase_estimate',
        biReport: '/store/{storeId}/tmobile/checkout/{orderId}/bi_report',
    },

    tradein: {
        eligibility: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/eligibility', // post
        bySerialNumber: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/bySerialNumber', // post
        byProgramType: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/byProgramType/{programType}', // get
        questions: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/questions', // get
        estimateQuote: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/quote', // post
        basicPromo: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/basic_promo', // post
        updateTradeIn: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/updatetradein', // put
        deleteTradeIn: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/deletetradein', // DELETE
        addTradeIn: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/addtradein', // post
        browsePromo: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/promo_search', // post
        postQuote: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/quote', // put
        searchQuotation: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/search_quotation', // post
        getItemTradeinInfo: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/itemTradeinInfo', // get
        getAllTradeinInfo: '/store/{storeId}/tmobile/cart/{orderId}/device/orderTradeinInfo', // get
        rmaCancel: '/store/{storeId}/tmobile/cart/{orderId}/device/{orderItemId}/tradein/quote', // put
        generatetoken: '/store/{storeId}/tmobile/cart/{orderId}/toggledata'
    },
    dormant:
    {
        dormantUrl: '/store/{storeId}/tmobile/dormant'
    }
};
